import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-fiche',
  templateUrl: './admin-fiche.component.html',
  styleUrls: ['./admin-fiche.component.scss'],
})
export class AdminFicheComponent {}
